module.exports = __webpack_public_path__ + "img/login_bg.68f02420.png";